import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";

/* Custom Code */

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSelectedCategoryPath } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCatalogPageStateByPath } from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import useLanguage from "@store/Framework/Common/GoogleAnalytics/hooks/utilities/useLanguage";
import isBodyEmpty from "@store/Framework/Common/Utilities/emptyBody";
import parse from "@store/Framework/Common/Utilities/parseFullPageHtml";
import { connect, ResolveThunks } from "react-redux";
/* Custom Code */

interface Props extends WidgetProps {}

export interface CategoryDetailDescriptionFooterStyles {
    container?: InjectableCss;
}

export const bannerStyles: CategoryDetailDescriptionFooterStyles = {};

const styles = bannerStyles;

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state);
    const categoryPath =
        getSelectedCategoryPath(state) ||
        (location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname);
    const catalogPageState = getCatalogPageStateByPath(state, categoryPath);
    return {
        properties: catalogPageState.value?.properties,
    };
};

const mapDispatchToProps = {};

const CategoryDetailFooterDescription = ({
    properties,
}: Props & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>) => {
    const lang = useLanguage();
    const propertyName = `categoryFooterDescription_${lang}`;
    if (!properties || !(propertyName in properties) || isBodyEmpty(properties[propertyName])) {
        return null;
    }

    return (
        <StyledWrapper {...styles.container} data-test-selector={propertyName}>
            {parse(properties[propertyName] ?? "", parserOptions)}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CategoryDetailFooterDescription),
    definition: {
        group: "Category Details",
        icon: "folder-bookmark",
        allowedContexts: ["CategoryDetailsPage", "ProductListPage"],
    },
};

export default widgetModule;
